import { Navigate } from 'react-router-dom';
import { inferRouteObject } from 'react-router-typed-object';

import { and, or, PrivateRoute, Roles } from '@/js/libs/use-auth';

import Notifications from 'src/scenes/Notifications';
import { notificationsQueryParamsSchema } from 'src/scenes/Notifications/pages/SystemNotifications/types';
import Status from 'src/scenes/Status';

const index = true;

export const notificationsRouteObject = inferRouteObject({
  path: 'notifications',
  element: <Notifications.Helmet />,
  children: [
    {
      path: 'comments',
      element: <PrivateRoute roles={and(or(Roles.ADMIN, Roles.AGENCY))} noAccessComponent={Status.NotFound} />,
      children: [{ index, Component: Notifications.Comments }],
    },
    { path: 'system', Component: Notifications.SystemNotifications, searchParams: notificationsQueryParamsSchema.parse },
    { index, element: <Navigate to='./system' replace /> },
  ],
});
